import ajax from '@/utils/ajax';
import { head } from '../personal/personalSet';
/**
 * 获取用户学习时常
 */
export async function reqLearnTotalTime() {
  const { data } = await ajax(`${head}/v1/user/course/statistics`);
  return data;
}

/**
 * 获取用户课程列表
 */
export async function reqCourseList(params) {
  const { data } = await ajax(`${head}/v1/user/course/course-list`, params);
  return data;
}

/**
 * 获取课程详情
 * @param {*} params 开课记录ID
 */
export async function reqCourseDetail(params) {
  const { data } = await ajax(`${head}/v1/user/course/info`, params);
  return data;
}

/**
 * 获取电子讲义列表
 * @param {*} params
 */
export async function reqLectureList(params) {
  const { data } = await ajax(`${head}/v1/lecture/curriculum`, params);
  return data;
}

/**
 * 获取课程目录
 * @param {*} id 课程ID
 */
export async function reqCourseTree(id) {
  const { data } = await ajax(`${head}/v1/course/catalog/${id}`);
  return data;
}

/**
 * 获取当前产品社群信息
 * @param {*} params
 * productId: 产品ID
 * productSkuId: 产品SKUID
 */
export async function reqCommunityInfo(params) {
  const { data } = await ajax(`${head}/v1/community/detail/product`, params);
  return data;
}

/**
 * 根据开课ID校验用户是否买了该课程
 * id: 开课记录ID
 */
export async function reqCheckUserCourse(id) {
  const { data } = await ajax(`${head}/v1/user/course/open-course-record`, { id });
  return data;
}

// 节点下资源列表
export const reqGetNodeResource = (data) => ajax(`${head}/v1/course/curriculum/node/${data.nodeId}/resource`);

// 校验课表、章节、资源
export const reqGetCheckCourse = (data) => ajax(`${head}/v1/course/curriculum/check`, data);

// 视频反馈信息
export const videoFeedback = (data) => ajax(`${head}/v1/feedback`, data, 'post');

// 获取清晰度字典表
export const reqQualities = (type) => ajax(`${head}/v1/dictionary/type/${type}`);
